.picker { width: 300px; display: flex; flex-direction: column; max-height: 380px; }
.searchWrap { padding: 10px; border-bottom: 1px solid var(--border-cell); }
.search {
  width: 100%; padding: 8px 10px; font: inherit; font-size: 12px;
  border: 1px solid var(--border-control); border-radius: 6px; outline: none; color: var(--text-value);
}
.search:focus { border-color: #2f6feb; box-shadow: 0 0 0 3px rgba(47, 111, 235, 0.1); }
.list { overflow-y: auto; padding: 6px; flex: 1 0 0; }
.opt {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  width: 100%; padding: 8px 10px; border-radius: 6px; text-align: left;
  font-size: 12px; line-height: 16px; color: var(--text-value);
}
.opt:hover { background: var(--bg-table-header); }
.opt.active { background: var(--bg-row-selected); font-weight: 600; }
.name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tick { color: #2f6feb; flex-shrink: 0; }
.state { padding: 16px 12px; font-size: 12px; color: var(--text-muted); text-align: center; }
.footer { padding: 8px 10px; border-top: 1px solid var(--border-cell); }
.clear {
  width: 100%; padding: 7px; border-radius: 6px; font-size: 12px; font-weight: 500;
  color: var(--text-value); border: 1px solid var(--border-control); background: #fff;
}
.clear:hover { background: var(--bg-table-header); }
